import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { Focusable, FocusEventListener, Keyboardable, KeyboardEventListener } from '@philips-emr/tws-core/lib/component/types';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';
import { ValidatorFunction } from '@philips-emr/tws-core/lib/services/model-service';
import { isEnumValid, isValidWidth } from '@philips-emr/tws-utils';

import { FieldVisibility } from './constants';

export interface Validators<T> {
  [key: string]: ValidatorFunction<T>;
}

abstract class BaseFieldAPI extends ComponentAPI implements Changeable<Value>, Focusable, Keyboardable {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<Value>();

  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onKeyDown = new KeyboardEventListener();

  /** @event */
  @AwesomeEvent
  onKeyPress = new KeyboardEventListener();

  /** @event */
  @AwesomeEvent
  onKeyUp = new KeyboardEventListener();

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }

  getData(): Record<string, Value> {
    return this.state.data;
  }

  setData(data: Record<string, Value>): void {
    this.setState({ data });
  }

  getEntry(): string {
    return this.state.entry;
  }

  setEntry(entry: string): void {
    this.setState({ entry });
  }

  getLabel(): string {
    return this.state.label;
  }

  setLabel(label: string): void {
    this.setState({ label });
  }

  setWidth(width: number): void {
    if (isValidWidth(width)) {
      this.setState({ width });
    }
  }

  getWidth(): number {
    return this.state.width;
  }

  setMDWidth(mdWidth: number): void {
    this.setState({ mdWidth });
  }

  geMDtWidth(): number {
    return this.state.mdWidth;
  }

  setSMWidth(smWidth: number): void {
    this.setState({ smWidth });
  }

  getSMWidth(): number {
    return this.state.smWidth;
  }

  setXSMWidth(xsmWidth: number): void {
    this.setState({ xsmWidth });
  }

  getXSMWidth(): number {
    return this.state.xsmWidth;
  }

  setVisibility(visibility: FieldVisibility): void {
    if (!isEnumValid(FieldVisibility, visibility)) return;

    this.setState({ visibility });
  }

  getVisibility(): FieldVisibility {
    return this.state.visibility;
  }

  isAlwaysShowLabel(): boolean {
    return this.state.alwaysShowLabel;
  }

  setAlwaysShowLabel(alwaysShowLabel: boolean): void {
    this.setState({ alwaysShowLabel });
  }

  abstract getValue(): Value;

  abstract setValue(value: Value): void;

}

export default BaseFieldAPI;
